import {mapGetters, mapState} from "vuex";

export default {
    data() {
        return {
            mobileControls: false,
            mobileClick: false
        }
    },
    computed:{
        ...mapGetters('config', ['branding']),
        ...mapGetters('screen', [ 'isMobileAndTablet']),
        ...mapState('scale', ['currentScale']),
        ...mapGetters('landingPage',['currentFlyer']),
        isVideo() {
            const products = this.blockData?.products || [];
            const prod = products.find((prod) => {
                const actionType = (prod.actionType || prod.sku).toLowerCase();
                return (actionType.includes('inblock') || actionType.includes('animate'));
            })
            return prod;
        },
        source() {
            const contentSource = this.isVideo.contentSource || this.isVideo.url
            return contentSource.includes('metrocommonapi') ?  `${contentSource}${this.config?.accessKey || ''}` : `${contentSource}${this.currentFlyer?.config?.branding?.accessKey}` || '';
        },
        isAutoplay() {
            return this.isVideo?.inblockAutoplay ?? true;
        },
        hasAudio() {
            return this.isVideo?.inblockAudio ?? false;
        },
        muteBtnIcon() {
            return this.videoMuted ? '/icons/in-block-video/unmute.svg' : "/icons/in-block-video/mute.svg";
        },
        playBtnIcon() {
            return this.videoPlaying ? "/icons/in-block-video/pause.svg" : "/icons/in-block-video/play.svg";
        },
        isLoop() {
            return this.isVideo?.inblockLoop ?? true;
        },
        showControls() {
            if(this.fileFormat=== 'webm' || this.fileFormat === 'svg') return;
            return this.isVideo?.inblockControls ?? true;
        },
        isPop() {
            return this.isVideo?.noPop ?? false;
        },
        inverseScaling() {
            const inverseScale = 1/this.currentScale
            return { transform: `scaleY(${inverseScale})`,
            transformOrigin: 'center bottom' }
        },
        inverseImgScaling() {
            return { transform: `scaleY(${this.currentScale})`,
            minHeight: `${32/this.currentScale}px`,
            maxHeight: `${31/this.currentScale}px`,
            maxWidth: `100%` }
        },
        fileFormat() {
            const url = this.isVideo?.contentSource || this.isVideo?.url;
            if(url.endsWith('.webm')) {
                return 'webm'
            } else if (url.endsWith('.svg')) {
                return 'svg'
            }
            return null;
        }
		
    },
    methods: {
        handleClick(){
            if(this.isMobileAndTablet) {
             if (!this.showControls) {
              this.$emit('videoClicked')
             } else {
              if(!this.mobileClick) {
                this.mobileControls = true;
              } else {
                this.$emit('videoClicked')
              }
              this.mobileClick = !this.mobileClick
             }
            } else { 
              this.$emit('videoClicked')
            }
           },
           
    }
}